export default __webpack_public_path__ + "05d899849b726a61eb02e6d10f74ae42.png";